import { takeLatest, call, put, all } from 'redux-saga/effects';
import ContentfulClient from 'utils/ContentfulClient';
import { fetchPromotionAssets as fetchPromotionImages } from 'utils/contentfulUtils';
import { FETCH_PROMOTION_ASSETS } from './constants';
import {
  fetchPromotionAssetsSuccess,
  fetchPromotionAssetsFailure,
} from './actions';

const contentfulClient = new ContentfulClient();

function* fetchPromotionAssets() {
  try {
    const response = yield call(fetchPromotionImages, contentfulClient);
    yield put(fetchPromotionAssetsSuccess(response));
  } catch (error) {
    yield put(fetchPromotionAssetsFailure(error));
  }
}

export default function* rootSaga() {
  yield all([takeLatest(FETCH_PROMOTION_ASSETS, fetchPromotionAssets)]);
}
